import FalzonSite from './pages/FalzonSite';
export default function App() { return <FalzonSite />; }
